import { useQuery } from "@apollo/client";

import { ProjectDeliverablesScreen_GetDeliverablesDocument } from "./queries.generated";

export function useProjectGetDeliverables(projectId: string, researchTypeId: string, plannerAreaIds: string[]) {
    const {
        data: newData,
        previousData,
        loading,
        error,
    } = useQuery(ProjectDeliverablesScreen_GetDeliverablesDocument, {
        variables: { projectId, researchTypeId, plannerAreaIds },
    });

    const data = newData ?? previousData;

    return {
        maps: data?.maps,
        tables: data?.tables,
        loading,
        error,
    };
}
